export const mockData = {
  stats: [
    { number: "+500", label: "Familias ayudadas" },
    { number: "95%", label: "Casos resueltos" },
    { number: "15+", label: "Años de experiencia" }
  ],
  
  benefits: [
    {
      icon: "Shield",
      title: "Cancela tus deudas",
      description: "Elimina definitivamente las deudas que no puedes pagar, incluyendo préstamos, tarjetas de crédito e hipotecas."
    },
    {
      icon: "Heart",
      title: "Recupera tu tranquilidad",
      description: "Pon fin al estrés, las llamadas de bancos y la angustia. Vuelve a dormir tranquilo."
    },
    {
      icon: "CheckCircle",
      title: "Protege tu patrimonio",
      description: "Salvaguarda tu vivienda habitual y los bienes necesarios para tu vida diaria y trabajo."
    },
    {
      icon: "Scale",
      title: "100% Legal y efectivo",
      description: "Un derecho reconocido por la ley española. Miles de personas ya lo han conseguido."
    }
  ],
  
  process: [
    {
      title: "Contacta con nosotros",
      description: "Escríbenos por WhatsApp o llámanos. Te escuchamos sin compromiso y con total confidencialidad."
    },
    {
      title: "Analizamos tu caso",
      description: "Estudiamos tu situación financiera y determinamos la mejor estrategia legal."
    },
    {
      title: "Iniciamos el proceso",
      description: "Preparamos y presentamos toda la documentación necesaria ante el juzgado."
    },
    {
      title: "Cancelas tus deudas",
      description: "El juez aprueba la cancelación y recuperas tu libertad financiera."
    }
  ],
  
  features: [
    {
      icon: "Users",
      title: "Trato personalizado",
      description: "Cada caso es único. Te acompañamos en cada paso del proceso con cercanía y profesionalidad."
    },
    {
      icon: "FileText",
      title: "Experiencia demostrada",
      description: "Más de 15 años asesorando en derecho concursal y cientos de casos resueltos con éxito."
    },
    {
      icon: "Clock",
      title: "Rapidez y eficacia",
      description: "Agilizamos todos los trámites para que puedas empezar tu nueva vida cuanto antes."
    },
    {
      icon: "Shield",
      title: "Máxima confidencialidad",
      description: "Tu información está protegida. Trabajamos con total discreción y profesionalidad."
    }
  ],
  
  testimonials: [
    {
      initials: "MC",
      name: "María C.",
      detail: "Canceló 45.000€ en deudas",
      text: "No veía salida. Tenía deudas de tarjetas y préstamos que no podía pagar. Gracias a Perea Abogados cancelé todas mis deudas y ahora puedo mirar al futuro con esperanza. Eternamente agradecida."
    },
    {
      initials: "JL",
      name: "José Luis R.",
      detail: "Salvó su negocio familiar",
      text: "Mi negocio quebró y arrastraba deudas imposibles. El equipo de Perea me ayudó con el concurso de acreedores y conseguí salvar mi casa y empezar de cero. Son unos profesionales excepcionales."
    },
    {
      initials: "AP",
      name: "Ana P.",
      detail: "Nueva vida sin deudas",
      text: "Estaba desesperada, con una hipoteca impagable y préstamos. Ellos me explicaron todo con claridad y se encargaron de todo. Hoy soy libre y puedo volver a vivir en paz."
    }
  ],
  
  faqs: [
    {
      question: "¿Qué es la Ley de Segunda Oportunidad?",
      answer: "Es una ley que permite a personas físicas cancelar definitivamente las deudas que no pueden pagar, siempre que se cumplan ciertos requisitos. Es un derecho legal reconocido en España desde 2015 que ya ha ayudado a miles de familias."
    },
    {
      question: "¿Qué deudas puedo cancelar?",
      answer: "Se pueden cancelar deudas con bancos, préstamos personales, tarjetas de crédito, deudas hipotecarias, deudas con proveedores y otras deudas privadas. También parte de las deudas con Hacienda y Seguridad Social en algunos casos."
    },
    {
      question: "¿Perderé mi casa?",
      answer: "No necesariamente. La ley protege la vivienda habitual en muchos casos. Analizamos tu situación específica para encontrar la mejor solución que proteja tu patrimonio esencial."
    },
    {
      question: "¿Cuánto tiempo dura el proceso?",
      answer: "El proceso suele durar entre 6 y 18 meses dependiendo de la complejidad del caso y el juzgado. Trabajamos para agilizar al máximo todos los trámites."
    },
    {
      question: "¿Cuánto cuesta el servicio?",
      answer: "Ofrecemos presupuestos personalizados según cada caso y opciones de pago flexibles. En la consulta analizamos tu situación y te damos un presupuesto claro y cerrado antes de que decidas nada, sin compromiso."
    },
    {
      question: "¿Puedo acogerme si soy autónomo?",
      answer: "Sí, tanto personas físicas como autónomos pueden beneficiarse de la Ley de Segunda Oportunidad. Analizamos tu caso particular en la consulta gratuita."
    }
  ]
};
